import { z } from 'zod'

export const createUserSchema = z.object({
  email: z.email({ error: 'O e-mail fornecido é inválido.' }),
  companyId: z.uuid(),
})

export type CreateUserSchema = z.infer<typeof createUserSchema>
